import { ComponentProps, forwardRef } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { splitViewItemWrapperClass } from './SplitView.css';

export const SplitViewItemWrapper = forwardRef<HTMLDivElement, ComponentProps<'div'>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={getClassNames(splitViewItemWrapperClass, className)} {...props} />
  ),
);

SplitViewItemWrapper.displayName = 'SplitViewItemWrapper';
